
{
  "familyId": "STU-TIJDLIJN",
  "questions": [
    {
      "id": "STU-TIJDLIJN-001",
      "familyId": "STU-TIJDLIJN",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_tijdlijn",
      "questionType": "multiple_choice",
      "question": "Op een tijdlijn staat 1600 links en 1900 rechts. Waar staat het jaar 1750 ongeveer?",
      "options": ["In het midden", "Helemaal links", "Helemaal rechts", "Op driekwart"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Tijdlijn aflezen", "content": "Een tijdlijn loopt van oud (links) naar nieuw (rechts). Het midden van 1600-1900 is (1600+1900)÷2 = 1750. Dus 1750 staat precies in het midden.", "icon": "lightbulb"}}],
      "conceptId": "tijdlijn_positie",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De tijdlijn loopt van 1600 tot 1900 — dat is 300 jaar. Het midden is 1600 + 150 = 1750. Dus 1750 staat precies in het midden.",
        "solutionSteps": ["Bereik: 1900 − 1600 = 300 jaar", "Midden: 300 ÷ 2 = 150 jaar vanaf het begin", "1600 + 150 = 1750 → precies in het midden"],
        "distractorExplanations": {
          "0": "Goed! 1750 ligt precies in het midden tussen 1600 en 1900.",
          "1": "Je dacht waarschijnlijk dat 1750 dicht bij het begin staat. Maar helemaal links is 1600. 1750 is 150 jaar later, dus meer naar het midden. Onthoud: reken het verschil uit.",
          "2": "Je dacht waarschijnlijk dat 1750 dicht bij het einde staat. Maar helemaal rechts is 1900. 1750 is 150 jaar eerder, dus meer naar het midden.",
          "3": "Je dacht waarschijnlijk dat 1750 op driekwart staat. Maar op driekwart zou 1825 zijn (1600 + 225). 1750 is eerder, namelijk in het midden."
        }
      }
    },
    {
      "id": "STU-TIJDLIJN-002",
      "familyId": "STU-TIJDLIJN",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_tijdlijn",
      "questionType": "multiple_choice",
      "question": "Op een tijdlijn staan drie gebeurtenissen: A (1945), B (1969), C (1989). Hoeveel jaar zit er tussen A en C?",
      "options": ["44 jaar", "24 jaar", "20 jaar", "64 jaar"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Tijdsverschil berekenen", "content": "Trek het vroegste jaar af van het laatste jaar: 1989 − 1945 = 44 jaar.", "icon": "lightbulb"}}],
      "conceptId": "tijdlijn_verschil",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het verschil tussen A en C: 1989 − 1945 = 44 jaar. Let op: je rekent van A naar C, niet van A naar B of B naar C.",
        "solutionSteps": ["A = 1945, C = 1989", "Verschil: 1989 − 1945 = 44 jaar"],
        "distractorExplanations": {
          "0": "Goed! 1989 − 1945 = 44 jaar.",
          "1": "Je dacht waarschijnlijk dat je van A naar B moest rekenen. Maar 24 jaar is het verschil tussen A en B (1969 − 1945). De vraag is A tot C. Onthoud: lees goed welke punten gevraagd worden.",
          "2": "Je dacht waarschijnlijk dat je van B naar C moest rekenen. Maar 20 jaar is het verschil tussen B en C (1989 − 1969). De vraag is A tot C.",
          "3": "Je dacht waarschijnlijk dat je alle jaren bij elkaar moet optellen. Maar 64 klopt niet. 1989 − 1945 = 44, niet 64. Onthoud: trek af, tel niet op."
        }
      }
    },
    {
      "id": "STU-TIJDLIJN-003",
      "familyId": "STU-TIJDLIJN",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_tijdlijn",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over een tijdlijn is JUIST?",
      "options": ["Tijd loopt van links (oud) naar rechts (nieuw)", "Het nieuwste staat altijd links", "Een tijdlijn heeft geen vaste richting", "Jaren staan altijd op gelijke afstand"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Regels van een tijdlijn", "content": "Een tijdlijn loopt standaard van links (oud/vroeger) naar rechts (nieuw/later). De afstanden zijn evenredig: 100 jaar neemt altijd evenveel ruimte in.", "icon": "lightbulb"}}],
      "conceptId": "tijdlijn_regels",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een tijdlijn loopt standaard van links (oud) naar rechts (nieuw). Dit is de afspraak, net zoals we van links naar rechts lezen.",
        "solutionSteps": ["Links = oud/vroeger", "Rechts = nieuw/later", "Dit is de standaard afspraak"],
        "distractorExplanations": {
          "0": "Goed! Tijd loopt van links (oud) naar rechts (nieuw).",
          "1": "Je dacht waarschijnlijk dat het nieuwste links staat. Maar het is andersom: het oudste staat links, het nieuwste rechts. Onthoud: links = oud, rechts = nieuw.",
          "2": "Je dacht waarschijnlijk dat een tijdlijn geen vaste richting heeft. Maar een tijdlijn heeft wél een vaste richting: van links naar rechts.",
          "3": "Je dacht waarschijnlijk dat jaren altijd op gelijke afstand staan. Jaren staan op evenredige afstand (100 jaar = altijd even lang), maar niet alle tijdlijnen tonen elk jaar apart."
        }
      }
    },
    {
      "id": "STU-TIJDLIJN-004",
      "familyId": "STU-TIJDLIJN",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_tijdlijn",
      "questionType": "multiple_choice",
      "question": "Een tijdlijn toont de Romeinse tijd (0-400), de Middeleeuwen (500-1500) en de Gouden Eeuw (1600-1700). Welke periode duurde het langst?",
      "options": ["De Middeleeuwen (1000 jaar)", "De Romeinse tijd (400 jaar)", "De Gouden Eeuw (100 jaar)", "Ze duurden allemaal even lang"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Duur berekenen op een tijdlijn", "content": "De duur van een periode = eindjaar − beginjaar. Middeleeuwen: 1500 − 500 = 1000 jaar. Romeinse tijd: 400 − 0 = 400 jaar. Gouden Eeuw: 1700 − 1600 = 100 jaar.", "icon": "lightbulb"}}],
      "conceptId": "tijdlijn_duur",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Bereken de duur: Middeleeuwen = 1500 − 500 = 1000 jaar. Romeinse tijd = 400 jaar. Gouden Eeuw = 100 jaar. De Middeleeuwen duurden het langst.",
        "solutionSteps": ["Middeleeuwen: 1500 − 500 = 1000 jaar", "Romeinse tijd: 400 − 0 = 400 jaar", "Gouden Eeuw: 1700 − 1600 = 100 jaar", "1000 > 400 > 100 → Middeleeuwen langst"],
        "distractorExplanations": {
          "0": "Goed! De Middeleeuwen duurden 1000 jaar, het langst van de drie.",
          "1": "Je dacht waarschijnlijk dat de Romeinse tijd het langst duurde. Maar de Romeinse tijd duurde 400 jaar — dat is korter dan de Middeleeuwen (1000 jaar). Onthoud: reken de duur uit.",
          "2": "Je dacht waarschijnlijk dat de Gouden Eeuw het langst duurde. Maar de Gouden Eeuw duurde maar 100 jaar — dat is de kortste periode.",
          "3": "Je dacht waarschijnlijk dat ze even lang duurden. Maar 1000, 400 en 100 jaar zijn heel verschillend. Onthoud: bereken eindjaar − beginjaar."
        }
      }
    },
    {
      "id": "STU-TIJDLIJN-005",
      "familyId": "STU-TIJDLIJN",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_tijdlijn",
      "questionType": "ordering",
      "question": "Zet deze gebeurtenissen in de juiste volgorde op de tijdlijn (oudst eerst).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Uitvinding van de boekdrukkunst (1450)", "Ontdekking van Amerika (1492)", "Begin Tachtigjarige Oorlog (1568)", "Stichting VOC (1602)"],
        "correctOrder": [0, 1, 2, 3]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Chronologische volgorde", "content": "Chronologisch = van oud naar nieuw. Kijk naar de jaartallen: 1450 → 1492 → 1568 → 1602.", "icon": "lightbulb"}}],
      "conceptId": "tijdlijn_ordenen",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De juiste chronologische volgorde is: boekdrukkunst (1450) → Amerika (1492) → Tachtigjarige Oorlog (1568) → VOC (1602).",
        "solutionSteps": ["1450: Boekdrukkunst (Gutenberg)", "1492: Ontdekking Amerika (Columbus)", "1568: Begin Tachtigjarige Oorlog", "1602: Stichting VOC"]
      }
    }
  ]
}
